import * as React from 'react';
import styled from 'styled-components';

const FolderWrapper = styled.div``;

const FolderHeader = styled.div`
    display: flex;
    flex-direction: row;
`;
const FolderHeaderLeft = styled.div<{ color: string; size: 'lg' | 'md' | 'sm' }>`
    ${(props) => props.size == 'md' && 'width: 20px;'};
    ${(props) => props.size == 'md' && 'height: 8px;'};
    ${(props) => props.size == 'sm' && 'width: 8px;'};
    ${(props) => props.size == 'sm' && 'height: 3px;'};
    background-color: ${(props) => props.color}!important;
    opacity: 0.8;
`;
const FolderHeaderRight = styled.div<{ color: string; size: 'lg' | 'md' | 'sm' }>`
    width: 0;
    height: 0;
    ${(props) => props.size === 'md' && `border-bottom: 8px solid ${props.color};!important`};
    ${(props) => props.size === 'md' && 'border-right: 8px solid transparent;'};
    ${(props) => props.size === 'sm' && `border-bottom: 3px solid ${props.color};!important`};
    ${(props) => props.size === 'sm' && 'border-right: 3px solid transparent;'};
    opacity: 0.8;
`;
const FolderContent = styled.div<{ color: string; size: 'lg' | 'md' | 'sm' }>`
    ${(props) => props.size === 'md' && 'width: 40px;'};
    ${(props) => props.size === 'md' && 'height: 28px;'};
    ${(props) => props.size === 'sm' && 'width: 20px;'};
    ${(props) => props.size === 'sm' && 'height: 14px;'};
    border-top-right-radius: 2px;
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    background-color: ${(props) => props.color}!important;
`;

import { JRCFolderProps } from './types';

const JRCFolder = (props: JRCFolderProps) => {
    const { color, size } = props;
    return (
        <FolderWrapper>
            <FolderHeader>
                <FolderHeaderLeft color={color} size={size}></FolderHeaderLeft>
                <FolderHeaderRight color={color} size={size}></FolderHeaderRight>
            </FolderHeader>
            <FolderContent color={color} size={size}></FolderContent>
        </FolderWrapper>
    );
};

export { JRCFolder };
